import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';

import { AirBookingService } from 'libraries/service/booking/airBooking.service';
import { IAirPlace } from 'libraries/service/resources/model/booking/air/IAirPlace';
import { IGetBookingsAirResponse } from 'libraries/service/resources/booking/interfaces/IGetBookings';
import { faArrowRight, IconDefinition } from "@fortawesome/free-solid-svg-icons";

@Component({
    selector: 'booking-sectors',
    template: `
    <ul *ngIf="trips && trips.length"
        class="trips">
        <li *ngFor="let trip of trips">
            <ul class="trip">
                <ng-container *ngFor="let stop of trip; let last = last">
                    <li>
                        <span [title]="stop?.city?.name || '?'">{{ stop?.airport?.code || "?"}}</span>
                        <fa-icon [icon]="iconArrowRight" *ngIf="!last" ></fa-icon>
                    </li>
                </ng-container>
            </ul>
        </li>
    </ul>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: [`
        ul {
            padding: 0;
        }

        ul, li {
            display: inline-block;
        }

        .trips > li {
            margin-right: 10px;
        }

        .trips > li:last {
            margin-right: 0;
        }
    `]
})
export class BookingSectorsComponent implements OnChanges {
    @Input()
    public booking: IGetBookingsAirResponse;

    public trips: IAirPlace[][] | null;

    public iconArrowRight: IconDefinition = faArrowRight;

    constructor(
        private readonly airBookingService: AirBookingService
    ) { }

    public ngOnChanges(changes: SimpleChanges): void {
        this.trips = changes.booking.currentValue ? this.airBookingService.getTrip(this.booking) : null;
    }

}
